import React from "react"
import * as styles from "./horizontal-line-separator-desktop.module.scss"

export default function HorizontalLineSeparatorDesktop(props) {
    return  <div className={styles.horizontalLine}/>
}
